/* import __COLOCATED_TEMPLATE__ from './sprint-bracket-page.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class SprintBracketPage extends Component 
{				
	get quarterfinalsLLs()
	{
		return this.calculateLLFromQuarters(this.args.quarterfinalsResults);
	}

	get quarterfinalsResultsForDisplay()
	{
		// Ensure LLs are calculated first so isLL flags are set
		this.quarterfinalsLLs;
		return this.args.quarterfinalsResults;
	}

	get semifinalsLLs()
	{
		return this.calculateLLFromSemis(this.args.semifinalsResults);
	}

	get semifinalsResultsWithLLs()
	{
		// Ensure LLs are calculated first so isLL flags are set
		this.semifinalsLLs;
		return this.args.semifinalsResults;
	}

	get semifinalsResultsForDisplay()
	{
		let results = this.args.semifinalsResults;

		let S1Results = this.filterResultsForClassGroup(results,this.args.semifinalsClassGroups[0]);
		let S2Results = this.filterResultsForClassGroup(results,this.args.semifinalsClassGroups[1]);

		//populate display results with start list live from QF results until a real
		//start list has been created, then just return the real results
		if(this.args.showQuarterfinals && (S1Results.length == 0 && S2Results.length == 0))
		{
			return this.calculateSemisAssignmentFromQuarters();
		}
		else
		{
			return this.semifinalsResultsWithLLs;
		}
	}
	
	get finalsResultsForDisplay()
	{
		let results = this.args.finalsResults;
		
		let AResults = this.filterResultsForClassGroup(results,this.args.finalsClassGroups[0]);
		let BResults = this.filterResultsForClassGroup(results,this.args.finalsClassGroups[1]);
		
		//populate display results with start list live from SF results until a real
		//start list has been created, then just return the real results
		if(AResults.length == 0 && BResults.length == 0)
		{
			return this.calculateFinalsAssignmentFromSemis();
		}
		else
		{
			return results;
		}
	}
	
	filterResultsForClassGroup(results,classGroupId)
	{
		if(results == null)
			return [];
		
		return results.filter(function(result)
		{
			return result.ClassGroupId == classGroupId;
		});
	}
	
	finishedOnlyFilter(result)
	{
		return result.totalTimeInMilliseconds != undefined;
	}
	
	sortFn(a,b)
	{
		//records with time above those without
		let aTime = a.totalTimeInMilliseconds;
		let bTime = b.totalTimeInMilliseconds;
	
		let aStatus = a.status;
		let bStatus = b.status;
	
		//always rank SUS status at bottom
		if(aStatus == "SUS" || aStatus == "RAL")
			return 1;
		if(bStatus == "SUS" || bStatus == "RAL")
			return -1
	
		if(aTime != null && bTime != null)
			return aTime>bTime ? 1 : aTime<bTime ? -1 : (a.id>b.id?1:-1);
		if(aTime != null)
			return -1;
		if(bTime != null)
			return 1;
		return (a.id>b.id?1:-1);		
	}
	
	calculateLLFromQuarters(results)
	{	
		//get results for each classgroup		
		let Q1Results = this.filterResultsForClassGroup(results,this.args.quarterfinalsClassGroups[0]);
		let Q2Results = this.filterResultsForClassGroup(results,this.args.quarterfinalsClassGroups[1]);
		let Q3Results = this.filterResultsForClassGroup(results,this.args.quarterfinalsClassGroups[2]);
		let Q4Results = this.filterResultsForClassGroup(results,this.args.quarterfinalsClassGroups[3]);
		let Q5Results = this.filterResultsForClassGroup(results,this.args.quarterfinalsClassGroups[4]);
		
		let Q1ResultsFiltered = Q1Results.filter(this.finishedOnlyFilter);
		let Q2ResultsFiltered = Q2Results.filter(this.finishedOnlyFilter);
		let Q3ResultsFiltered = Q3Results.filter(this.finishedOnlyFilter);
		let Q4ResultsFiltered = Q4Results.filter(this.finishedOnlyFilter);
		let Q5ResultsFiltered = Q5Results.filter(this.finishedOnlyFilter);
		
		Q1ResultsFiltered.sort(this.sortFn);
		Q2ResultsFiltered.sort(this.sortFn);
		Q3ResultsFiltered.sort(this.sortFn);
		Q4ResultsFiltered.sort(this.sortFn);
		Q5ResultsFiltered.sort(this.sortFn);
		
		let LL1 = null;
		let LL1Time = null
		let LL2 = null;
		let LL2Time = null;
		
		//find the fastest 3/4th place result with an OK status and valid time
		let testTimeLL1 = function(result)
		{
			if(result == undefined) return;
			
			if(result.status == 'OK' &&
				result.totalTimeInMilliseconds != null &&
				(result.totalTimeInMilliseconds <  LL1Time || LL1Time == null))
			{
				LL1 = result;
				LL1Time = result.totalTimeInMilliseconds;
			}
		};
		//find the second fastest 3/4th place result with an OK status and valid time
		let testTimeLL2 = function(result)
		{
			if(result == undefined) return;
			
			if(result.status == 'OK' &&
				result.totalTimeInMilliseconds != null &&
				result.totalTimeInMilliseconds > LL1Time &&
				(result.totalTimeInMilliseconds <  LL2Time || LL2Time == null))
			{
				LL2 = result;
				LL2Time = result.totalTimeInMilliseconds;
			}
		};
		
		testTimeLL1(Q1ResultsFiltered[2]);
		testTimeLL1(Q1ResultsFiltered[3]);
		testTimeLL1(Q2ResultsFiltered[2]);
		testTimeLL1(Q2ResultsFiltered[3]);
		testTimeLL1(Q3ResultsFiltered[2]);
		testTimeLL1(Q3ResultsFiltered[3]);
		testTimeLL1(Q4ResultsFiltered[2]);
		testTimeLL1(Q4ResultsFiltered[3]);
		testTimeLL1(Q5ResultsFiltered[2]);
		testTimeLL1(Q5ResultsFiltered[3]);
		
		testTimeLL2(Q1ResultsFiltered[2]);
		testTimeLL2(Q1ResultsFiltered[3]);
		testTimeLL2(Q2ResultsFiltered[2]);
		testTimeLL2(Q2ResultsFiltered[3]);
		testTimeLL2(Q3ResultsFiltered[2]);
		testTimeLL2(Q3ResultsFiltered[3]);
		testTimeLL2(Q4ResultsFiltered[2]);
		testTimeLL2(Q4ResultsFiltered[3]);
		testTimeLL2(Q5ResultsFiltered[2]);
		testTimeLL2(Q5ResultsFiltered[3]);
		
		const LLs = [];
		if(LL1 != null)
		{
			LL1.isLL = true;
			LLs.push(LL1);
		}
		if(LL2 != null)
		{
			LL2.isLL = true;
			LLs.push(LL2);
		}

		LLs.sort(function(a,b)
		{
			let aIsLL = a.isLL;
			let bIsLL = b.isLL;
			let aTime = a.totalTimeInMilliseconds;
			let bTime = b.totalTimeInMilliseconds;
			
			if(aIsLL && bIsLL)
				return aTime > bTime;
			if(aIsLL)
				return -1;
			if(bIsLL)
				return 1;
			return aTime > bTime;
		})
		return LLs;
	}
	
	calculateLLFromSemis(results)
	{		
		//get results for each classgroup		
		let S1Results = this.filterResultsForClassGroup(results,this.args.semifinalsClassGroups[0]);
		let S2Results = this.filterResultsForClassGroup(results,this.args.semifinalsClassGroups[1]);
		
		S1Results = S1Results.filter(this.finishedOnlyFilter);
		S2Results = S2Results.filter(this.finishedOnlyFilter);
		
		S1Results.sort(this.sortFn);
		S2Results.sort(this.sortFn);
			
		let LL1 = null;
		let LL1Time = null
		let LL2 = null;
		let LL2Time = null;
		
		//find the fastest 3/4th place result with an OK status and valid time
		let testTimeLL1 = function(result)
		{
			if(result == undefined) return;
			
			if(result.status == 'OK' &&
				result.totalTimeInMilliseconds != null &&
				(result.totalTimeInMilliseconds <  LL1Time || LL1Time == null))
			{
				LL1 = result;
				LL1Time = result.totalTimeInMilliseconds;
			}
		};
		//find the second fastest 3/4th place result with an OK status and valid time
		let testTimeLL2 = function(result)
		{
			if(result == undefined) return;
			
			if(result.status == 'OK' &&
				result.totalTimeInMilliseconds != null &&
				result.totalTimeInMilliseconds > LL1Time &&
				(result.totalTimeInMilliseconds <  LL2Time || LL2Time == null))
			{
				LL2 = result;
				LL2Time = result.totalTimeInMilliseconds;
			}
		};
		
		testTimeLL1(S1Results[2]);
		testTimeLL1(S1Results[3]);
		testTimeLL1(S2Results[2]);
		testTimeLL1(S2Results[3]);
		
		testTimeLL2(S1Results[2]);
		testTimeLL2(S1Results[3]);
		testTimeLL2(S2Results[2]);
		testTimeLL2(S2Results[3]);
		
		let LLs = [];
		if(LL1 != null)
		{
			LL1.isLL = true;
			LLs.push(LL1);
		}
		if(LL2 != null)
		{
			LL2.isLL = true;
			LLs.push(LL2);
		}
		return LLs;
	}

	calculateSemisAssignmentFromQuarters()
	{		
		let S1Assignments = [];
		let S2Assignments = [];
		
		let quarterfinalsResults = this.args.quarterfinalsResults;
		
		//get results for each classgroup
		let Q1Results = this.filterResultsForClassGroup(quarterfinalsResults,this.args.quarterfinalsClassGroups[0]);
		let Q2Results = this.filterResultsForClassGroup(quarterfinalsResults,this.args.quarterfinalsClassGroups[1]);
		let Q3Results = this.filterResultsForClassGroup(quarterfinalsResults,this.args.quarterfinalsClassGroups[2]);
		let Q4Results = this.filterResultsForClassGroup(quarterfinalsResults,this.args.quarterfinalsClassGroups[3]);
		let Q5Results = this.filterResultsForClassGroup(quarterfinalsResults,this.args.quarterfinalsClassGroups[4]);
		
		let Q1ResultsFiltered = Q1Results.filter(this.finishedOnlyFilter);
		let Q2ResultsFiltered = Q2Results.filter(this.finishedOnlyFilter);
		let Q3ResultsFiltered = Q3Results.filter(this.finishedOnlyFilter);
		let Q4ResultsFiltered = Q4Results.filter(this.finishedOnlyFilter);
		let Q5ResultsFiltered = Q5Results.filter(this.finishedOnlyFilter);
		
		Q1ResultsFiltered.sort(this.sortFn);
		Q2ResultsFiltered.sort(this.sortFn);
		Q3ResultsFiltered.sort(this.sortFn);
		Q4ResultsFiltered.sort(this.sortFn);
		Q5ResultsFiltered.sort(this.sortFn);
		
		
		if(Q1ResultsFiltered.length > 0)
			S1Assignments.push(Object.assign({},Q1ResultsFiltered[0]));
		if(Q1ResultsFiltered.length > 1)
			S1Assignments.push(Object.assign({},Q1ResultsFiltered[1]));
		if(Q2ResultsFiltered.length > 0)
			S1Assignments.push(Object.assign({},Q2ResultsFiltered[0]));
		if(Q2ResultsFiltered.length > 1)
			S1Assignments.push(Object.assign({},Q2ResultsFiltered[1]));
		if(Q3ResultsFiltered.length > 0)
			S1Assignments.push(Object.assign({},Q3ResultsFiltered[0]));
		
		if(Q4ResultsFiltered.length > 0)
			S2Assignments.push(Object.assign({},Q4ResultsFiltered[0]));
		if(Q4ResultsFiltered.length > 1)
			S2Assignments.push(Object.assign({},Q4ResultsFiltered[1]));
		if(Q5ResultsFiltered.length > 0)
			S2Assignments.push(Object.assign({},Q5ResultsFiltered[0]));
		if(Q5ResultsFiltered.length > 1)
			S2Assignments.push(Object.assign({},Q5ResultsFiltered[1]));
		if(Q3ResultsFiltered.length > 1)
			S2Assignments.push(Object.assign({},Q3ResultsFiltered[1]));
		
		//lucky losers
		const LLs = this.quarterfinalsLLs;
		if(LLs.length > 0)
			S2Assignments.push(Object.assign({},LLs[0]));
		if(LLs.length > 1)
			S1Assignments.push(Object.assign({},LLs[1]));

		let tempIds=0;
		for(let assignment of S1Assignments)
		{
			assignment.ClassGroupId=this.args.semifinalsClassGroups[0];
			assignment.place = null;
			assignment.totalTimeInMilliseconds = null;
			assignment.isLL = false;
			assignment.id=tempIds;
			tempIds++;
		}
		for(let assignment of S2Assignments)
		{
			assignment.ClassGroupId=this.args.semifinalsClassGroups[1];
			assignment.place = null;
			assignment.totalTimeInMilliseconds = null;
			assignment.isLL = false;
			assignment.id=tempIds;
			tempIds++;
		}

		return S1Assignments.concat(S2Assignments);
	}

	calculateFinalsAssignmentFromSemis()
	{
		let AAssignments = [];
		let BAssignments = [];
		
		let semifinalsResults = this.args.semifinalsResults;
		
		//get results for each classgroup
		let S1Results = this.filterResultsForClassGroup(semifinalsResults,this.args.semifinalsClassGroups[0]);
		let S2Results = this.filterResultsForClassGroup(semifinalsResults,this.args.semifinalsClassGroups[1]);
		
		let S1ResultsFiltered = S1Results.filter(this.finishedOnlyFilter);
		let S2ResultsFiltered = S2Results.filter(this.finishedOnlyFilter);
		
		S1ResultsFiltered.sort(this.sortFn);
		S2ResultsFiltered.sort(this.sortFn);
		
		let LLs = this.semifinalsLLs;
		let LL1 = LLs[0];
		let LL2 = LLs[1];
		
		if(S1ResultsFiltered.length > 0)
			AAssignments.push(Object.assign({},S1ResultsFiltered[0]));
		if(S2ResultsFiltered.length > 0)
			AAssignments.push(Object.assign({},S2ResultsFiltered[0]));
		if(S1ResultsFiltered.length > 1)
			AAssignments.push(Object.assign({},S1ResultsFiltered[1]));
		if(S2ResultsFiltered.length > 1)
			AAssignments.push(Object.assign({},S2ResultsFiltered[1]));
		
		//everyone else who isnt an LL into the B final
		if(S1ResultsFiltered.length > 2 && S1ResultsFiltered[2] != LL1 && S1ResultsFiltered[2] != LL2)
		{
			BAssignments.push(Object.assign({},S1ResultsFiltered[2]));
		}
		if(S2ResultsFiltered.length > 2 && S2ResultsFiltered[2] != LL1 && S2ResultsFiltered[2] != LL2)
		{
			BAssignments.push(Object.assign({},S2ResultsFiltered[2]));
		}
		if(S1ResultsFiltered.length > 3 && S1ResultsFiltered[3] != LL1 && S1ResultsFiltered[3] != LL2)
		{
			BAssignments.push(Object.assign({},S1ResultsFiltered[3]));
		}
		if(S2ResultsFiltered.length > 3 && S2ResultsFiltered[3] != LL1 && S2ResultsFiltered[3] != LL2)
		{
			BAssignments.push(Object.assign({},S2ResultsFiltered[3]));
		}
		
		if(S1ResultsFiltered.length > 4)
			BAssignments.push(Object.assign({},S1ResultsFiltered[4]));
		if(S2ResultsFiltered.length > 4)
			BAssignments.push(Object.assign({},S2ResultsFiltered[4]));
		if(S1ResultsFiltered.length > 5)
			BAssignments.push(Object.assign({},S1ResultsFiltered[5]));
		if(S2ResultsFiltered.length > 5)
			BAssignments.push(Object.assign({},S2ResultsFiltered[5]));
		
		if(LLs.length > 0)
			AAssignments.push(Object.assign({},LLs[0]));
		if(LLs.length > 1)
			AAssignments.push(Object.assign({},LLs[1]));

		let tempIds=0;
		for(let assignment of AAssignments)
		{
			assignment.ClassGroupId=this.args.finalsClassGroups[0];
			assignment.place = null;
			assignment.totalTimeInMilliseconds = null;
			assignment.isLL = false;
			assignment.id=tempIds;
			tempIds++;
		}
		for(let assignment of BAssignments)
		{
			assignment.ClassGroupId=this.args.finalsClassGroups[1];
			assignment.place = null;
			assignment.totalTimeInMilliseconds = null;
			assignment.isLL = false;
			assignment.id=tempIds;
			tempIds++;
		}
		return AAssignments.concat(BAssignments);
	}
}
